module.exports = __webpack_public_path__ + "img/success.4f765738.png";